import type React from 'react';

import Download from './assets/icon_download.svg';
import Practice from './assets/icon_practice.svg';
import RolePlay from './assets/icon_role_play.svg';
import Scenario from './assets/icon_scenario.svg';
import Video from './assets/icon_video.svg';

type LessonIconProps = {
  contentType: string;
};

export const LessonIcon: React.FC<LessonIconProps> = ({ contentType }) => {
  let IconComponent = null;

  switch (contentType) {
    case 'document':
      IconComponent = <img src={Download} alt="" />;
      break;
    case 'practice':
      IconComponent = <img src={Practice} alt="" />;
      break;
    case 'scenario':
      IconComponent = <img src={Scenario} alt="" />;
      break;
    case 'movie':
      IconComponent = <img src={Video} alt="" />;
      break;
    case 'goal_setting':
      IconComponent = <img src={Practice} alt="" />;
      break;
    case 'self_summarizing':
      IconComponent = <img src={Practice} alt="" />;
      break;
    case 'role_play':
    case 'goal_dialog':
    case 'reflection':
      IconComponent = <img src={RolePlay} alt="" />;
      break;
    default:
      IconComponent = null;
      break;
  }

  return <>{IconComponent}</>;
};
